import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { useCustomValuePreviewActions } from "PFApp/components/custom_value_preview/use_custom_value_preview";
import { ProfileCustomValuesList } from "PFApp/components/custom_values_list";
import { ParentChildMap } from "PFApp/helpers/get_parent_child_skills_map";
import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { generateMatchCustomValues } from "PFCore/helpers/custom_value";
import { useIsUnbiasedMode } from "PFCore/hooks/use_is_unbiased_mode";
import { useSkillsType } from "PFCore/hooks/use_skills_type";
import { ActivityPureCustomValue, CustomValueScope, Id, MatchCustomValue } from "PFTypes";

import css from "./table_cells.module.scss";

type SkillsCellProps = {
  profileId: Id;
  matchSkills: MatchCustomValue[];
  roleSkills: ActivityPureCustomValue[];
  parentChildMap?: ParentChildMap;
};

export const SkillsCell = ({ profileId, matchSkills, roleSkills, parentChildMap }: SkillsCellProps) => {
  const activity = useCurrentActivity();
  const isUnbiasedMode = useIsUnbiasedMode(activity?.reviewers);

  const { showPreview } = useCustomValuePreviewActions();
  const skillsType = useSkillsType();
  const matchAndActivityCustomValues = generateMatchCustomValues(matchSkills, roleSkills);

  const label = roleSkills.length > 0 ? `${matchSkills.length}/${roleSkills.length}` : matchSkills.length;

  return (
    <Tooltip
      content={
        <div className={css.skillsTooltip}>
          <ProfileCustomValuesList
            customFieldName="skills"
            customValues={matchAndActivityCustomValues}
            parentChildMap={parentChildMap}
            profileId={profileId}
            onMissingClick={(customValueId) => {
              showPreview({
                scope: CustomValueScope.Activity,
                customTypeId: skillsType!.id,
                customValueId,
                activityId: activity.id
              });
            }}
            experienceTooltipDisabled
            dark
            isUnbiasedMode={isUnbiasedMode}
          />
        </div>
      }
      disabled={matchAndActivityCustomValues.length === 0}
      interactive
      triggerContainerProps={{
        className: css.skillsTooltipTrigger
      }}
      tooltipContainerProps={{
        style: { maxWidth: 500 }
      }}
    >
      <Typography variant="bodyBold" tag="span" className={css.skillsCount}>
        {label}
      </Typography>
    </Tooltip>
  );
};
